import { Stack, styled } from 'shell/components';

const SettingsFieldRow = ({ label, children, ...props }) => (
    <Row {...props}>
        {label}
        <Control>{children}</Control>
    </Row>
);

const Row = styled(Stack)(({ theme }) => ({
    alignItems: 'flex-start',
    flexDirection: 'row',
    gap: theme.spacing(5),
    justifyContent: 'space-between',

    [theme.breakpoints.down('desktop')]: {
        flexDirection: 'column',
    },
}));

const Control = styled(Stack)(() => ({
    maxWidth: 400,
    width: '100%',
}));

export default SettingsFieldRow;
